import { ContentCard } from 'components/Card';
import { Text } from 'components/Text';
import { getTrans } from 'modules/i18n';
import { ProgressBar } from './ProgressBar';
import { StepNavigationButton } from './StepNavigationButton';
import { RootBox } from './styledComponents';

export const Overview = () => (
  <RootBox>
    <ContentCard
      title={getTrans('cvBuilderPage.overview.progress.title')}
      titleVariant="h4"
    >
      <ProgressBar showPercentage={true} showSteps={false} size="large" />
    </ContentCard>
    <ContentCard
      title={getTrans('cvBuilderPage.overview.personalDetails.title')}
      titleVariant="h4"
    >
      <Text variant="body2">
        {getTrans('cvBuilderPage.overview.personalDetails.body')}
      </Text>
    </ContentCard>
    <ContentCard
      title={getTrans('cvBuilderPage.overview.education.title')}
      titleVariant="h4"
    >
      <Text variant="body2">
        {getTrans('cvBuilderPage.overview.education.body')}
      </Text>
    </ContentCard>
    <ContentCard
      title={getTrans('cvBuilderPage.overview.professionalExperience.title')}
      titleVariant="h4"
    >
      <Text variant="body2">
        {getTrans('cvBuilderPage.overview.professionalExperience.body')}
      </Text>
    </ContentCard>
    <ContentCard
      title={getTrans('cvBuilderPage.overview.hardSkills.title')}
      titleVariant="h4"
    >
      <Text variant="body2">
        {getTrans('cvBuilderPage.overview.hardSkills.body')}
      </Text>
    </ContentCard>
    <ContentCard
      title={getTrans('cvBuilderPage.overview.softSkills.title')}
      titleVariant="h4"
    >
      <Text variant="body2">
        {getTrans('cvBuilderPage.overview.softSkills.body')}
      </Text>
    </ContentCard>
    <ContentCard
      title={getTrans('cvBuilderPage.overview.languageSkills.title')}
      titleVariant="h4"
    >
      <Text variant="body2">
        {getTrans('cvBuilderPage.overview.languageSkills.body')}
      </Text>
    </ContentCard>
    <ContentCard
      title={getTrans('cvBuilderPage.overview.certificates.title')}
      titleVariant="h4"
    >
      <Text variant="body2">
        {getTrans('cvBuilderPage.overview.certificates.body')}
      </Text>
    </ContentCard>
    <StepNavigationButton step="OVERVIEW">
      {getTrans('cvBuilderPage.overview.button')}
    </StepNavigationButton>
  </RootBox>
);
